import { fetchPostByLocale } from "@/(admin)/modules/post/services/post"
import { filterOption } from "@/lib/external-components"
import { ComponentConfig } from "@measured/puck"
import { message, Select } from "antd"
import { useEffect, useState } from "react"
import { PostData } from "../../../types"
import { ArticlesProps, RenderSinglePost } from "./RenderConfig"

const SelectCategoryAndPost = ({ value, onChange }: any) => {
  const [postOptions, setPostOptions] = useState<{ value: string; label: string }[]>([])
  const [lang, setLang] = useState<string>()

  const fetchPostsByLang = async (lang: string) => {
    try {
      if (!lang) {
        setPostOptions([])
        return
      }

      const response = await fetchPostByLocale(lang)
      const posts = response?.data

      if (posts && posts.length > 0) {
        setPostOptions(
          posts.map((post: PostData) => ({
            value: post.id,
            label: post.attributes.name,
          })),
        )
      } else {
        message.warning("No posts found for the selected category.")
        setPostOptions([])
      }
    } catch (err) {
      message.error("Failed to fetch posts. Please try again.")
    }
  }

  useEffect(() => {
    if (lang) {
      fetchPostsByLang(lang)
    }
  }, [lang])

  const handlePostChange = (selectedValue: string | null) => {
    onChange({ post: selectedValue || undefined })
  }

  return (
    <div>
      <Select
        showSearch
        style={{ minWidth: "14rem" }}
        placeholder="Select Language"
        optionFilterProp="children"
        filterOption={filterOption}
        options={[
          { label: "EN", value: "en" },
          { label: "VI", value: "vi" },
        ]}
        allowClear
        value={lang}
        onChange={setLang}
      />
      {lang && (
        <Select
          showSearch
          placeholder="Select Post"
          value={value.post}
          onChange={handlePostChange}
          options={postOptions}
          style={{ width: "14rem", marginTop: "1rem", overflow: "hidden" }}
          allowClear
        />
      )}
    </div>
  )
}

export const SinglePost: ComponentConfig<ArticlesProps> = {
  label: "CaoCao | Single Post",
  fields: {
    category: {
      label: "Category and Post",
      type: "custom",
      render: ({ value, onChange, field }: any) => {
        return <SelectCategoryAndPost value={value || { post: undefined }} onChange={onChange} />
      },
    },
    locale: {
      label: "Language",
      type: "select",
      options: [
        { label: "English", value: "en" },
        { label: "Tiếng Việt", value: "vi" },
      ],
    },
    type: {
      label: "Layout Type",
      type: "select",
      options: [
        { label: "Fluid", value: "fluid" },
        { label: "Custom", value: "custom" },
        { label: "Boxed", value: "boxed" },
      ],
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    gapCustom: "83px",
    heightContact: "388px",
    type: "fluid",
    className: "",
    locale: "en",
  },
  ...RenderSinglePost,
}
